// Central content for Epic Consultancy

export const SITE = {
  name: "Epic Consultancy",
  founder: "Charmaine Laville",
  role: "Founder & Principal Consultant",
  tagline: "Strengthening Children's Services Through Leadership, Partnership and Innovation",
  email: "charmaine@epic-consultancy.co.uk",
  website: "www.epic-consultancy.co.uk",
  linkedin: "https://www.linkedin.com/",
};

export const KEYWORKER = {
  url: "https://pocketkeyworker.app",
  tagline: "One platform helping every young person grow.",
};

export const IMAGES = {
  heroAbstract:
    "https://images.unsplash.com/photo-1640654694019-b9d3567c0e56?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  charmaine:
    "/charmaine.png",
  keyworker:
    "/young-person-app.png",
  keyworkerApp:
    "/pocket-keyworker-app.jpg",
  partnerships:
    "https://images.pexels.com/photos/7698712/pexels-photo-7698712.jpeg?auto=compress&cs=tinysrgb&w=1400",
  care:
    "https://images.unsplash.com/photo-1554721299-e0b8aa7666ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  office:
    "https://images.unsplash.com/photo-1704655295066-681e61ecca6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  govAdvisory:
    "https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg?auto=compress&cs=tinysrgb&w=1400",
  digital:
    "https://images.pexels.com/photos/3183197/pexels-photo-3183197.jpeg?auto=compress&cs=tinysrgb&w=1400",
};

export const PILLARS = [
  {
    id: "childrens-services-development",
    number: "01",
    icon: "Building2",
    title: "Children's Services Development",
    summary:
      "Helping organisations establish, strengthen and transform children's services.",
    image: IMAGES.care,
    items: [
      "Supported Accommodation Consultancy",
      "Residential Care Development",
      "Children's Service Design",
      "Independent Living Programmes",
      "Leaving Care Services",
      "Operational Development",
      "Referral & Placement Readiness",
      "Service Improvement",
      "Start-up Consultancy for New Providers",
      "Service Mobilisation",
    ],
  },
  {
    id: "safeguarding-governance-quality",
    number: "02",
    icon: "ShieldCheck",
    title: "Safeguarding, Governance & Quality",
    summary:
      "Helping organisations create safe, compliant and high-quality services.",
    image: IMAGES.office,
    items: [
      "Safeguarding Reviews",
      "Governance Frameworks",
      "Policy Development",
      "Quality Assurance",
      "Compliance",
      "Risk Management",
      "Inspection Readiness",
      "Operational Audits",
      "Regulatory Improvement",
    ],
  },
  {
    id: "leadership-workforce-development",
    number: "03",
    icon: "Users",
    title: "Leadership & Workforce Development",
    summary:
      "Helping organisations develop confident leaders and high-performing teams.",
    image: IMAGES.partnerships,
    items: [
      "Executive Coaching",
      "Leadership Development",
      "Workforce Planning",
      "Recruitment Strategy",
      "Safer Recruitment",
      "Staff Training",
      "Organisational Culture",
      "Supervision Frameworks",
      "Team Development",
    ],
  },
  {
    id: "government-strategic-advisory",
    number: "04",
    icon: "Landmark",
    title: "Government & Strategic Advisory",
    summary:
      "Supporting governments and senior leaders through collaboration, knowledge sharing and strategic advice.",
    image: IMAGES.govAdvisory,
    items: [
      "Children's Rights",
      "Youth Participation",
      "Strategic Planning",
      "Service Transformation",
      "Policy Development",
      "Capacity Building",
      "Independent Living Strategy",
      "Advisory Support",
    ],
  },
  {
    id: "digital-innovation",
    number: "05",
    icon: "Sparkles",
    title: "Digital Innovation",
    summary:
      "Helping organisations embrace digital solutions that improve outcomes.",
    image: IMAGES.digital,
    items: [
      "Pocket Keyworker",
      "Digital Transformation",
      "Life Skills Platforms",
      "Youth Wellbeing",
      "Digital Engagement",
      "Technology for Children's Services",
    ],
  },
];

export const CLIENTS = [
  "Governments",
  "Government Ministries",
  "Local Authorities",
  "Children's Services Providers",
  "Residential Care Providers",
  "Supported Accommodation Providers",
  "Schools & Colleges",
  "NGOs",
  "Charities",
  "Faith Organisations",
  "Community Organisations",
  "Entrepreneurs establishing children's services",
  "International Organisations",
];

export const WHY_CHOOSE = [
  {
    icon: "Compass",
    title: "Practical Leadership",
    text: "Advice grounded in real operational leadership.",
  },
  {
    icon: "Lightbulb",
    title: "Strategic Thinking",
    text: "Turning policy into practical implementation.",
  },
  {
    icon: "Handshake",
    title: "Collaborative Partnership",
    text: "Working alongside organisations to create sustainable solutions.",
  },
  {
    icon: "Heart",
    title: "Child-Centred Excellence",
    text: "Every recommendation focuses on improving outcomes for children and young people.",
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "We partner, we don't prescribe.",
    text: "Rather than delivering isolated projects, we work in partnership with organisations to design, develop and transform services that improve outcomes for children and young people.",
  },
  {
    number: "02",
    title: "We turn strategy into practice.",
    text: "Policy only matters when it changes daily practice. We bridge the gap between ambition and delivery with practical, operational expertise.",
  },
  {
    number: "03",
    title: "We build capability that lasts.",
    text: "Sustainable improvement comes from confident leaders and high-performing teams. We leave organisations stronger than we found them.",
  },
  {
    number: "04",
    title: "We keep children at the centre.",
    text: "Every review, framework and recommendation returns to one question: does this create safer, stronger outcomes for children and young people?",
  },
];

// Placeholder testimonials — swap the quote/name/role with real client feedback when available.
export const TESTIMONIALS = [
  {
    quote:
      "Epic Consultancy helped us strengthen our safeguarding governance with clarity and confidence. The advice was practical, grounded and genuinely collaborative.",
    role: "Director of Children's Services",
    org: "UK Local Authority",
  },
  {
    quote:
      "Charmaine brings rare insight — combining real operational leadership with strategic thinking. Our new service launched with the right foundations from day one.",
    role: "Chief Executive",
    org: "Children's Services Provider",
  },
  {
    quote:
      "A trusted partner throughout. Epic Consultancy worked alongside our team, building capability that has lasted well beyond the engagement itself.",
    role: "Trustee",
    org: "National Children's Charity",
  },
];

export const KEYWORKER_FEATURES = [
  { icon: "ListChecks", title: "Life Skills Tracking", text: "Structured pathways that help young people build independence, one skill at a time." },
  { icon: "MessageCircle", title: "Keyworker Connection", text: "A trusted digital link between young people and the professionals who support them." },
  { icon: "HeartPulse", title: "Wellbeing Check-ins", text: "Gentle, regular prompts that surface how a young person is really doing." },
  { icon: "Target", title: "Goal Setting", text: "Personalised goals that celebrate progress and build confidence." },
  { icon: "BookOpen", title: "Resource Library", text: "Accessible guidance on money, health, housing and everyday life." },
  { icon: "ShieldCheck", title: "Safe by Design", text: "Built with safeguarding and data protection at its core." },
];

export const KEYWORKER_BENEFITS = [
  "Empowers young people to develop independence and confidence",
  "Strengthens the relationship between young people and keyworkers",
  "Provides organisations with meaningful engagement insight",
  "Supports the transition from care to independent living",
];

export const KEYWORKER_ROADMAP = [
  { phase: "Phase 1", title: "Concept & Co-Design", text: "Developing the vision with young people, keyworkers and providers at the centre." },
  { phase: "Phase 2", title: "Pilot Programmes", text: "Testing life-skills and wellbeing features with partner organisations." },
  { phase: "Phase 3", title: "Platform Launch", text: "A polished, accessible app supporting independence pathways at scale." },
  { phase: "Phase 4", title: "International Expansion", text: "Adapting Pocket Keyworker for children's services across the Caribbean and beyond." },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Our Expertise", to: "/expertise" },
  { label: "Meet Charmaine", to: "/meet-charmaine" },
  { label: "Pocket Keyworker", to: "/pocket-keyworker" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

export const ENQUIRY_TYPES = [
  "Book a Consultation",
  "Children's Services Development",
  "Safeguarding, Governance & Quality",
  "Leadership & Workforce Development",
  "Government & Strategic Advisory",
  "Digital Innovation",
  "General Enquiry",
];
